import { render, staticRenderFns } from "./SBSupplements.vue?vue&type=template&id=eb79afa0"
import script from "./SBSupplements.vue?vue&type=script&lang=js"
export * from "./SBSupplements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports